export default __webpack_public_path__ + "static/media/delievers1.12f2e178.jpg";